import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-8e606370"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "tags-con"
};
const _hoisted_2 = {
  class: "tags"
};
const _hoisted_3 = {
  class: "tag-content"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tag-circle"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tag = _resolveComponent("el-tag");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pageOpenedList, page => {
    return _openBlock(), _createBlock(_component_el_tag, {
      key: page.permissionCode,
      closable: page.closable,
      size: "large",
      class: _normalizeClass(["tag", _ctx.currentPage && _ctx.currentPage.path === page.path ? 'tag-active' : '']),
      onClose: $event => $options.tagClose(page),
      onContextmenu: _withModifiers($event => $options.openRightClickMenu(page, $event), ["prevent"]),
      onClick: $event => $options.tagClick(page)
    }, {
      default: _withCtx(() => [_createElementVNode("span", _hoisted_3, [_hoisted_4, _createTextVNode(" " + _toDisplayString(page.title), 1)])]),
      _: 2
    }, 1032, ["closable", "class", "onClose", "onContextmenu", "onClick"]);
  }), 128))]), _withDirectives(_createElementVNode("ul", {
    style: _normalizeStyle({
      left: $data.rightClickMenuLeft + 'px',
      top: $data.rightClickMenuTop + 'px'
    }),
    class: "tag-context-menu"
  }, [$data.selectedPage.closable ? (_openBlock(), _createElementBlock("li", {
    key: 0,
    onClick: _cache[0] || (_cache[0] = $event => $options.tagClose($data.selectedPage))
  }, "关闭")) : _createCommentVNode("", true), _createElementVNode("li", {
    onClick: _cache[1] || (_cache[1] = (...args) => $options.closeOthersPage && $options.closeOthersPage(...args))
  }, "关闭其他"), _createElementVNode("li", {
    onClick: _cache[2] || (_cache[2] = (...args) => $options.closeAllPage && $options.closeAllPage(...args))
  }, "关闭所有")], 4), [[_vShow, $data.rightClickMenuVisible]])]);
}